import { Input, Label } from './Checkbox.styles';
import type { CheckboxProps } from './Checkbox.types';

export function Checkbox({ checked, onChange, label, disabled }: CheckboxProps) {
  return (
    <Label data-disabled={disabled}>
      <Input
        type="checkbox"
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        disabled={disabled}
      />
      {label}
    </Label>
  );
}
